module.exports = __webpack_public_path__ + "img/页面图片修改2-7.9e302233.png";